import { render, staticRenderFns } from "./FileUploadComponent.vue?vue&type=template&id=0b64b4be&scoped=true&"
import script from "./FileUploadComponent.vue?vue&type=script&lang=js&"
export * from "./FileUploadComponent.vue?vue&type=script&lang=js&"
import style0 from "./FileUploadComponent.vue?vue&type=style&index=0&id=0b64b4be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b64b4be",
  null
  
)

export default component.exports